import { Component, Inject } from '@angular/core';
import {
	MAT_DIALOG_DATA,
	MatDialogRef,
	MatDialogContent,
	MatDialogActions,
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApiLoadingKeys, ApiService } from 'src/app/services/api.services';
import { LoadingIndicatorService } from 'src/app/services/loading-indicator.service';
import { MatDivider } from '@angular/material/list';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
	selector: 'app-deactivate-mobile-uuiddialog',
	templateUrl: './deactivate-mobile-uuiddialog.component.html',
	styleUrls: [
		'./deactivate-mobile-uuiddialog.component.scss',
		'../../common/main.scss',
	],
	imports: [
		MatDivider,
		CdkScrollable,
		MatDialogContent,
		MatProgressSpinner,
		MatDialogActions,
	],
})
export class DeactivateMobileUUIDDialogComponent {
	errorDeactivatingUser: boolean = false;
	getDeactivateMobileUUIDLoadingKey =
		ApiLoadingKeys.getWhitelistUserListForCompany;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: any,
		private readonly dialogRef: MatDialogRef<any>,
		private readonly apiService: ApiService,
		public readonly loadingService: LoadingIndicatorService,
		private readonly snackbar: MatSnackBar
	) {}

	async onDeactivateClicked() {
		try {
			await this.apiService.updateWhitelistStatus(
				this.data.user.id,
				{
					statusId: '3',
				},
				this.data.companyId
			);
			const confirmationText = $localize`:@@deactivateMobileUUID-mobileUUIDDeletedConfirmation:Mobile UUID has been deactivated.`;
			this.snackbar.open(confirmationText, undefined, {
				duration: 2000,
			});
			this.dialogRef.close(true);
		} catch (err) {
			this.errorDeactivatingUser = true;
			console.error(err);
		}
	}

	onCloseClicked(refresh: boolean): void {
		this.dialogRef.close(refresh);
	}

	getApiService() {
		return this.apiService;
	}
}
